import { useEffect, useState } from 'react';

const MEDIA_CLASS =
  'w-[clamp(300px,50vw,600px)] h-[clamp(200px,30vw,400px)] rounded-lg bg-white object-cover';

/** True when the visitor has asked their OS/browser to minimise motion. */
const usePrefersReducedMotion = () => {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return reduced;
};

const HomePageImageContent = ({
  imageUrl,
  videoUrl,
  title,
  content,
}: {
  /** Image to show. When `videoUrl` is set it is used as the poster / reduced-motion fallback. */
  imageUrl: string;
  /** Optional looping, muted video shown instead of the image (an MP4 is far lighter than a GIF). */
  videoUrl?: string;
  title: string;
  content: React.ReactNode;
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const showVideo = Boolean(videoUrl) && !prefersReducedMotion;

  return (
    <div
      style={{
        paddingLeft: "clamp(.2rem, 6vw, 8rem)",
        paddingRight: "clamp(.2rem, 6vw, 8rem)",
        paddingTop: "clamp(.2rem, 2vw, 6rem)",
        paddingBottom: "clamp(.2rem, 2vw, 4rem)",
      }}
      className="grid grid-cols-11 items-start mb-4 "
    >
      <div className="col-span-11 lg:col-span-5 py-2 flex justify-center lg:justify-start">
        <figure>
          {showVideo ? (
            <video
              className={MEDIA_CLASS}
              src={videoUrl}
              poster={imageUrl}
              aria-label={title}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
            />
          ) : (
            <img className={MEDIA_CLASS} src={imageUrl} alt={title} loading="lazy" decoding="async" />
          )}
        </figure>
      </div>
      <div className="col-span-11 lg:col-start-7 lg:col-span-5 py-4">
        <p className="title-text-size text-custom-secolor animated-content">
          {title}
        </p>
        <div className="custom__divider pb-4">
        </div>
        <div className="text-md text-justify content-text-size break-normal leading-relaxed">
          {content}
        </div>
      </div>
    </div>
  );
};

export default HomePageImageContent;
